import { type RootState } from "features/Application/store/store";

export const selectHomePageState = (state: RootState) => state.homePage.homePageContent;
export const selectUpcomingEventsState = (state: RootState) => state.homePage.homeUpcomingEvents;
export const selectRecentCoursesState = (state: RootState) => state.homePage.homeRecentCourses;
